export const setFeatureName = (featureName) => ({
  type: "SET_FEATURE_NAME",
  featureName: featureName,
});

export const loadSchema = (schema) => ({
  type: "LOAD_SCHEMA",
  clientSchema: schema,
});
export const loadInitialSchema = (initialSchema) => ({
  type: "LOAD_INITIAL_CLIENT_MASTER_SCHEMA",
  initialSchema: initialSchema,
});
export const loadMasterSchema = (masterSchema, rawMasterSchema) => ({
  type: "LOAD_MASTER_SCHEMA",
  masterSchema: masterSchema,
  rawMasterSchema: rawMasterSchema,
});
export const loadDefaultConfig = (defaultConfig) => ({
  type: "LOAD_DEFAULT_CONFIG",
  defaultConfig: defaultConfig,
});
export const loadConfig = (config, shouldUpdateInitial = false) => ({
  type: "SET_CONFIG_DETAILS",
  schemaDetails: config,
  shouldUpdateInitial: shouldUpdateInitial,
});

export const loadInitialConfig = (initialConfig) => ({
  type: "LOAD_INITIAL_CONFIG",
  initialConfig: initialConfig,
});

export const setFieldVisibility = (fieldVisibility) => ({
  type: "SET_FIELD_VISIBILITY",
  fieldVisibility: fieldVisibility,
});
export const setSchedulerError = (schedulerError) => ({
  type: "SET_SCHEDULER_ERROR",
  error: schedulerError,
});
export const loadDefaultUiSchema = (uiSchema) => ({
  type: "LOAD_DEFAULT_UI_SCHEMA",
  uiSchema: uiSchema,
});
export const loadClientUiSchema = (uiSchema) => ({
  type: "LOAD_CLIENT_UI_SCHEMA",
  uiSchema: uiSchema,
});
export const setReleaseVersion = (release_version) => ({
  type: "SET_RELEASE_VERSION",
  release_version: release_version,
});
export const setInitialReleaseVersion = (release_version) => ({
  type: "SET_INITIAL_RELEASE_VERSION",
  release_version: release_version,
});
export const setDefaultReleaseVersion = (release_version) => ({
  type: "SET_DEFAULT_RELEASE_VERSION",
  release_version: release_version,
});
export const loadReleaseVersions = (releaseVersions) => ({
  type: "LOAD_RELEASE_VERSIONS",
  releaseVersions: releaseVersions,
});
export const toggleSummaryConfirm = (disableConfirmCallback) => ({
  type: "TOGGLE_SUMMARY_CONFIRM",
  disableConfirmCallback: disableConfirmCallback,
});
export const toggleSummaryModal = (modalState) => ({
  type: "TOGGLE_SUMMARY_MODAL",
  modalState: modalState,
});

export const setSmConfigStatus = (status) => ({
  type: "SET_SM_CONFIG_STATUS",
  status: status,
});

export const setScheduledHistoryView = (
  scheduledHistoryView,
  shouldReset = false
) => ({
  type: "SET_SCHEDULED_HISTORY_VIEW",
  scheduledHistoryView: scheduledHistoryView,
  shouldReset: shouldReset,
});
export const loadScheduledDraftSet = (scheduleDraftSet) => ({
  type: "LOAD_SCHEDULED_DRAFT_SET",
  scheduleDraftSet: scheduleDraftSet,
});
export const loadScheduledDraft = (scheduleDraft) => ({
  type: "LOAD_SCHEDULED_DRAFT",
  scheduleDraft: scheduleDraft,
});
export const loadInitialScheduledDraft = (initialScheduleDraft) => ({
  type: "LOAD_INITIAL_SCHEDULED_DRAFT",
  initialScheduleDraft: initialScheduleDraft,
});
export const loadHistorySet = (historySet) => ({
  type: "LOAD_CONFIG_SCHEDULER_HISTORY",
  historySet: historySet,
});
export const setSummaryViewType = (summaryViewType) => ({
  type: "SET_SUMMARY_VIEW_TYPE",
  summaryViewType: summaryViewType,
});
export const isScheduleChanges = (isScheduleChanges) => ({
  type: "SET_SCHEDULE_CHANGES",
  isScheduleChanges: isScheduleChanges,
});
export const loadSummaryChangesReview = (
  summaryView,
  importedConfig = null
) => ({
  type: "LOAD_SUMMARY_CHANGES_REVIEW",
  summaryView: summaryView,
  importedConfig: importedConfig,
});
export const setRehydrate = (rehydrate) => ({
  type: "SET_REHYDRATE",
  rehydrate: rehydrate,
});
export const loadNewDefaultsPreview = (releaseVersion, newDefaultsSummary) => ({
  type: "LOAD_NEW_DEFAULTS_PREVIEW",
  releaseVersion: releaseVersion,
  newDefaultsSummary: newDefaultsSummary,
});
export const loadGeneralSummaryPreview = (generalSummary) => ({
  type: "LOAD_GENERAL_SUMMARY_PREVIEW",
  generalSummary: generalSummary,
});
export const resetSMSchedulerSetUp = () => ({
  type: "RESET_SCHEMA_SCHEDULER_SET_UP",
});
export const resetSMConfig = () => ({
  type: "RESET_SCHEMA_CONFIG",
});
export const setSMConfigSaveState = (configSaveState) => ({
  type: "SET_SCHEMA_CONFIG_SAVE_STATE",
  configSaveState: configSaveState,
});
export const enableSummaryPostAction = (enablePost) => ({
  type: "ENABLE_SUMMARY_POST",
  enablePost: enablePost,
});
export const setSelectedPreviewTab = (tab) => ({
  type: "SET_SELECTED_TAB",
  selectedTab: tab,
});

export const setExistingClients = (clients) => ({
  type: "SET_CLIENTS",
  existingClients: clients,
});
export const setNewClients = (id, name) => ({
  type: "SET_NEW_CLIENTS",
  newClient: { id, name },
});
export const deleteNewClients = (clientToBeDeleted) => ({
  type: "DELETE_NEW_CLIENTS",
  clientToBeDeleted: clientToBeDeleted,
});
export const setDeletedClients = (deletedClients) => ({
  type: "SET_DELETED_CLIENTS",
  deletedClients: deletedClients,
});
export const setSchemaSectionSummaryName = (schemaSectionSummaryName) => ({
  type: "SET_SYPI_SECTION_SUMMARY_NAME",
  schemaSectionSummaryName: schemaSectionSummaryName,
});
export const loadImportedInputs = (importedChanges) => ({
  type: "LOAD_IMPORTED_INPUTS",
  importedChanges: importedChanges,
});
export const mergeDefaultConfig = (mergedConfig, isArray) => ({
  type: "MERGE_DEFAULT_CONFIG",
  isArray: isArray,
  mergedConfig: mergedConfig,
});
export const loadSchemaSectionPreview = (
  schemaSectionConfigs,
  schemaSection,
  ctid,
  activeReleaseVersion,
  importedCTID,
  importedReleaseVersion,
  status
) => ({
  type: "LOAD_SCHEMA_SECTION_PREVIEW",
  schemaSectionConfigs: schemaSectionConfigs,
  schemaSection: schemaSection,
  ctid: ctid,
  activeReleaseVersion: activeReleaseVersion,
  importedCTID: importedCTID,
  importedReleaseVersion: importedReleaseVersion,
  status: status,
});
export const setFMLink = (fmLink) => ({
  type: "SET_FM_LINK",
  fmLink: fmLink,
});

export const setFMLinkList = (fmLinkList) => ({
  type: "SET_FM_LINK_LIST",
  fmLinkList: fmLinkList,
});

export const setFMLinkBucket = (fmLinkBucket) => ({
  type: "SET_FM_LINK_BUCKET",
  fmLinkBucket: fmLinkBucket,
});

export const clearFMLinks = () => ({
  type: "CLEAR_FM_LINKS",
});

export const removeFMLink = (fmLink) => ({
  type: "REMOVE_FM_LINK",
  fmLink: fmLink,
});
export const setFMLinkEditingMode = (fmLinkEditingMode) => ({
  type: "SET_FM_LINK_EDITING_MODE",
  fmLinkEditingMode: fmLinkEditingMode,
});
export const updateConfig = (config) => ({
  type: "UPDATE_CONFIG",
  config: config,
});
export const updateSchema = (schema) => ({
  type: "UPDATE_SCHEMA",
  schema: schema,
});
export const loadModifiedSchemas = (modifiedSchema, defaultModifiedSchema) => ({
  type: "LOAD_MODIFIED_SCHEMAS",
  modifiedSchema: modifiedSchema,
  defaultModifiedSchema: defaultModifiedSchema,
});
export const loadModifiedMasterSchemas = (modifiedMasterSchema) => ({
  type: "LOAD_MODIFIED_MASTER_SCHEMA",
  modifiedMasterSchema: modifiedMasterSchema,
});
export const loadInitialModifiedSchema = (schema) => ({
  type: "LOAD_INITIAL_MODIFIED_SCHEMA",
  initialSchema: schema,
});
export const setSearchValue = (searchValue) => ({
  type: "SCHEMA_SEARCH",
  searchValue: searchValue,
});
export const includeSchemaDefaults = (
  releaseVersion,
  includeSchemaDefaults
) => ({
  type: "INCLUDE_SCHEMA_DEFAULTS",
  releaseVersion: releaseVersion,
  includeSchemaDefaults: includeSchemaDefaults,
});
export const setSelectedReleaseVersions = (release_versions) => ({
  type: "SET_SELECTED_RELEASE_VERSIONS",
  release_versions: release_versions,
});
export const setSchemaType = (schemaType) => ({
  type: "SET_SCHEMA_TYPE",
  schemaType: schemaType,
});
export const setDeletedFields = (fields, client) => ({
  type: "SET_DELETED_FIELDS",
  client: client,
  fields: fields,
});
export const setActionTabs = (actionTabs) => ({
  type: "SET_ACTION_TABS",
  actionTabs: actionTabs,
});
export const setActionTab = (actionTab) => ({
  type: "SET_ACTION_TAB",
  actionTab: actionTab,
});
export const selectActionTab = (actionTab) => ({
  type: "SELECT_ACTION_TAB",
  actionTab: actionTab,
});
export const setClientVisibility = (clientVisibility) => ({
  type: "SET_CLIENT_VISIBILITY",
  clientVisibility: clientVisibility,
});
export const toggleSectionsModal = (modalState) => ({
  type: "TOGGLE_SECTIONS_MODAL",
  modalState: modalState,
});
export const loadSummarySections = (summarySections) => ({
  type: "LOAD_SUMMARY_SECTIONS",
  summarySections: summarySections,
});
export const setSelectedSections = (selectedSections) => ({
  type: "SET_SELECTED_SECTIONS",
  selectedSections: selectedSections,
});
